const handleFreeShippingProgressBar = () => {
    if (!window.cartProgressBarSettings?.show_cart_shipping_progressbar) {
        return;
    }
    if (window.currentMarket === 'indonesia' || window.currentMarket === 'australia') {
        return;
    }

    let findInterval = null;
    let countInterval = null;
    try {
        let parentElement = null;
        let thresholdCount = window.cartProgressBarSettings?.cart_shipping_progressbar_threshold || 2;

        findInterval = setInterval(() => {
            let updated = updateProgressBarEl();

            if (updated) {
                clearInterval(findInterval);
            }
        }, 500);

        let cartCount = wowcart?.cartItems?.item_count || 0;

        countInterval = setInterval(() => {
            const currentCount = wowcart?.cartItems?.item_count || 0;

            if (currentCount !== cartCount) {
                updateProgressBarEl();

                cartCount = currentCount;
            }
        }, 300);

        const updateProgressBarEl = () => {

            cartCount = wowcart?.cartItems?.item_count || 0;
            let finished = cartCount / thresholdCount >= 1;

            let header = window.cartProgressBarSettings?.cart_shipping_progressbar_header;
            let subText = window.cartProgressBarSettings?.cart_shipping_progressbar_subtext;
            let successText = window.cartProgressBarSettings?.cart_shipping_progressbar_success_text;
            let progressText = window.cartProgressBarSettings?.cart_shipping_progressbar_progress_text;

            subText = subText.replace('[[difference]]', thresholdCount - cartCount);
            progressText = progressText.replace('[[count]]', finished ? thresholdCount : cartCount);
            progressText = progressText.replace('[[thresholdCount]]', thresholdCount);

            let progressBarHtml = `
            <div class="shipping-heading-wrapper">
                <span>
                    ${finished ? `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M10 0C4.49 0 0 4.49 0 10C0 15.51 4.49 20 10 20C15.51 20 20 15.51 20 10C20 4.49 15.51 0 10 0ZM14.78 7.7L9.11 13.37C8.97 13.51 8.78 13.59 8.58 13.59C8.38 13.59 8.19 13.51 8.05 13.37L5.22 10.54C4.93 10.25 4.93 9.77 5.22 9.48C5.51 9.19 5.99 9.19 6.28 9.48L8.58 11.78L13.72 6.64C14.01 6.35 14.49 6.35 14.78 6.64C15.07 6.93 15.07 7.4 14.78 7.7Z" fill="#407A3E"/>
                    </svg>` :  `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M21.5 15.5C21.78 15.5 22 15.72 22 16V17C22 18.66 20.66 20 19 20C19 18.35 17.65 17 16 17C14.35 17 13 18.35 13 20H11C11 18.35 9.65 17 8 17C6.35 17 5 18.35 5 20C3.34 20 2 18.66 2 17V15C2 14.45 2.45 14 3 14H12.5C13.88 14 15 12.88 15 11.5V6C15 5.45 15.45 5 16 5H16.84C17.56 5 18.22 5.39 18.58 6.01L19.22 7.13C19.31 7.29 19.19 7.5 19 7.5C17.62 7.5 16.5 8.62 16.5 10V13C16.5 14.38 17.62 15.5 19 15.5H21.5Z" fill="#407A3E"/>
                        <path d="M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z" fill="#407A3E"/>
                        <path d="M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z" fill="#407A3E"/>
                        <path d="M22 12.53V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L21.74 11.54C21.91 11.84 22 12.18 22 12.53Z" fill="#407A3E"/>
                        <path d="M13.08 2H5.69C3.9 2 2.4 3.28 2.07 4.98H6.44C6.82 4.98 7.12 5.29 7.12 5.67C7.12 6.05 6.82 6.35 6.44 6.35H2V7.73H4.6C4.98 7.73 5.29 8.04 5.29 8.42C5.29 8.8 4.98 9.1 4.6 9.1H2V10.48H2.77C3.15 10.48 3.46 10.79 3.46 11.17C3.46 11.55 3.15 11.85 2.77 11.85H2V12.08C2 12.63 2.45 13.08 3 13.08H12.15C13.17 13.08 14 12.25 14 11.23V2.92C14 2.41 13.59 2 13.08 2Z" fill="#407A3E"/>
                        <path d="M2.07 4.98047H1.92H0.94C0.56 4.98047 0.25 5.29047 0.25 5.67047C0.25 6.05047 0.56 6.35047 0.94 6.35047H1.85H2V5.69047C2 5.45047 2.03 5.21047 2.07 4.98047Z" fill="#407A3E"/>
                        <path d="M1.85 7.73047H0.94C0.56 7.73047 0.25 8.04047 0.25 8.42047C0.25 8.80047 0.56 9.10047 0.94 9.10047H1.85H2V7.73047H1.85Z" fill="#407A3E"/>
                        <path d="M1.85 10.4805H0.94C0.56 10.4805 0.25 10.7905 0.25 11.1705C0.25 11.5505 0.56 11.8505 0.94 11.8505H1.85H2V10.4805H1.85Z" fill="#407A3E"/>
                    </svg>`}
                </span> 
                <span class="shipping-heading">${header}</span>
            </div>
            <div class="unlock-wrapper">
                <span class="remaining-unlock ${cartCount < thresholdCount ? '' : 'd-none'}">
                    ${subText}
                </span>
                <span class="unlocked ${finished ? '' : 'd-none'}">
                    ${successText}
                </span>
            </div>
            <div class="progressbar-wrapper">
                <div class="progressbar ${finished ? 'done' : ''}" style="width: ${(finished ? 1 : (cartCount / thresholdCount)) * 100}%;"></div>
            </div>
            <div>
                <span class="unlock-count">
                    ${progressText}
                </span>
            </div>`;

            let shippingProgressBarElement = document.createElement('div');
            shippingProgressBarElement.classList.add('shipping-progressbar');
            shippingProgressBarElement.innerHTML = progressBarHtml;

            parentElement = document.querySelector('#wowcart-drawer .wow-cart__top-section');
            let freeShippingElement = document.querySelector('#wowcart-drawer .wow-cart__top-section .shipping-progressbar');
            if (parentElement) {
                if (freeShippingElement) {
                    parentElement.removeChild(freeShippingElement);
                }
                parentElement.append(shippingProgressBarElement);

                return true;
            }

            return false;
        }
    }
    catch (e) {
        console.error('Shipping Progressbar error => ', e);
        if (findInterval) {
            clearInterval(findInterval);
        }
        if (countInterval) {
            clearInterval(countInterval);
        }
    }
}

document.addEventListener('DOMContentLoaded', handleFreeShippingProgressBar);
